// nabbed form https://scotch.io/tutorials/how-to-implement-a-custom-validator-directive-confirm-password-in-angular-2
import { Directive, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector:
        '[validateEqual][formControlName],[validateEqual][formControl],[validateEqual][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: EqualValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class EqualValidatorDirective implements Validator {
    @Input()
    validateEqual: any;

    validate(c: AbstractControl): { [key: string]: any } {
        // self value (e.g. retype password)
        const v = c.value;

        // control value (e.g. password)
        const e = c.root.get(this.validateEqual);

        // value not equal
        if (e && v !== e.value) {
            return {
                validateEqual: false
            };
        }
        return null;
    }
}
